// extracted by mini-css-extract-plugin
module.exports = {"pageHolder":"VoiceOrder_pageHolder__1aoLG"};